<template>
  <v-container>
    <v-sheet>
      <v-toolbar dense elevation="0">
        <v-toolbar-title class="subtitle-2 text-capitalize">
          My Transactions
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-divider />
      <router-view name="view" />
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  name: "Billing",
};
</script>

<style scoped></style>
